
import { PropOptions } from 'vue'
import SwitchCountry from '../../molecules/switch-country/index.vue'
import { HydratedSearchList as SearchList } from '@/components/molecules'
import { portals } from '~/enums'
import { RecommerceProduct } from '~/apis/clients/rest/recommerce/types'

const SEARCH_TOPIC = 'carriers'

export default {
  name: 'SearchCarriers',
  components: {
    SearchList,
    SwitchCountry,
  },
  props: {
    carriersData: {
      type: Object,
      required: true,
    } as PropOptions<RecommerceProduct>,
    direction: {
      type: String,
      default: 'ltr',
    } as PropOptions<'ltr' | 'rtl'>,
  },
  data() {
    return {
      showCountrySelector: false,
      selectedCarrier: {},
      countriesForProduct: [],
      newSlug: undefined,
    }
  },
  computed: {
    widthClasses(): string {
      return 'w-full sm:w-1/2 lg:w-1/3 mt-3 pr-1 sm:pr-2 xl:pr-3'
    },
    carriersListAlphabetical(): RecommerceProduct {
      const { carriersData } = this
      return carriersData.products?.sort((a, b) => {
        const aName = (a?.nameInCategoryPage || '').toLowerCase()
        const bName = (b?.nameInCategoryPage || '').toLowerCase()
        return aName.localeCompare(bName)
      })
    },
    portals() {
      return portals
    },
  },
  methods: {
    onSearchInputFocus(): void {
      this.$gtmEnhanced.searchInput(SEARCH_TOPIC)
    },
    onCarriersSearch(searchTerm): void {
      this.$gtmEnhanced.viewSearchResults(searchTerm, SEARCH_TOPIC)
    },
    onCarrierClick(carrier): void {
      this.$gtmEnhanced.trackBrandClick(carrier, SEARCH_TOPIC)

      this.newSlug = carrier.slug
      this.countriesForProduct = carrier.countries
      this.showCountrySelector = true
    },
  },
}
